module.exports = __webpack_public_path__ + "img/RedFEG-Tracker.b24ecdf7.png";